import { render, staticRenderFns } from "./jointReview.vue?vue&type=template&id=525c1086"
import script from "./jointReview.vue?vue&type=script&lang=js"
export * from "./jointReview.vue?vue&type=script&lang=js"
import style0 from "./jointReview.vue?vue&type=style&index=0&id=525c1086&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports